import { render } from "./CheckTransferForm.vue?vue&type=template&id=12ab5163&scoped=true"
import script from "./CheckTransferForm.vue?vue&type=script&lang=js"
export * from "./CheckTransferForm.vue?vue&type=script&lang=js"

import "./CheckTransferForm.vue?vue&type=style&index=0&id=12ab5163&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12ab5163"]])

export default __exports__